import React from "react";

const Dropdown = ({ Classes, name, id, size, value, option, label,SelectClass ,onChange,optionClass}) => {

  return (
    <>
      <div className={`${Classes}`}>
        <label for={`${id}`}>{`${label ?label :""}`}</label>
        <select className={`${SelectClass}`} id={`${id}`} name={`${name}`} size={`${size || 1}`} onChange={onChange}>    
        {option &&
          option.map((option, index) => {
            return (
              <>
              <option className={`${optionClass}`} value={`${option.value}`}>{`${option.name}`}</option>    
              </>
            );
          })}
           
            </select>
      </div>
    </>
  );
};

export default Dropdown;
